import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'relative inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium tracking-wide',
    'transition-[background-color,color,border-color,box-shadow,opacity] duration-300 ease-tide',
    'disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0',
  ],
  {
    variants: {
      variant: {
        primary:
          'bg-primary text-on-primary hover:bg-primary-hover shadow-[0_10px_30px_-14px_var(--dm-primary)]',
        outline:
          'border border-line-strong bg-transparent text-fg hover:border-primary hover:text-primary',
        subtle: 'border border-line bg-surface-elevated text-fg hover:border-line-strong',
        ghost: 'bg-transparent text-fg hover:bg-surface-elevated',
        link: 'h-auto rounded-none px-0 text-primary underline-offset-4 hover:underline',
        danger: 'bg-danger text-on-danger hover:opacity-90',
      },
      size: {
        sm: 'h-9 px-4 text-xs',
        md: 'h-11 px-6 text-sm',
        lg: 'h-13 px-8 text-base',
        icon: 'size-10 p-0',
      },
      block: { true: 'w-full' },
    },
    compoundVariants: [{ variant: 'link', className: 'h-auto px-0' }],
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
